import {FiXCircle} from 'react-icons/fi'

const OnlineMembers = ({users, showModal, setShowModal}) => {
    console.log(showModal)
    
    return (
        showModal ?
        <>
        <div  className="bg-gray-600 fixed top-0 left-0 w-full h-screen overflow-auto z-30 opacity-75">
        </div>
        <div className="fixed w-screen top-0 left-0  z-50">
        <div className="flex w-screen h-screen items-center justify-center">
          <div className="w-3/4 bg-white sm:w-1/2 h-64 sm:mx-auto rounded-lg overflow-auto">
            <h1 className="flex items-center justify-between bg-blue-600 px-5 py-3 text-xl rounded-t-lg text-white font-semibold">
               <span>
                   Online Members
                </span> 
                <span className="cursor-pointer" onClick={() => setShowModal(false)}><FiXCircle></FiXCircle></span></h1>
            <div className="p-4">

            <div>
              {users.map(user => <h1 key={user.name} className="capitalize p-2 text-red-600 font-semibold rounded-lg mb-3">{user.name}</h1>)}
            </div>
            </div>
          </div>
        </div>
        </div>
        </>:''
    )
}

export default OnlineMembers
